import { useState, useEffect } from "react";
import { Layout } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { getSessionData } from "../../utils/interceptors/localStorageService";
import { SelfUserClassificationEnum } from "../../shared/constants/constants";
import { useDashboardLayout } from "../../store/context/dashboard-layout-context";

const { Content, Sider } = Layout;

const PortalLayout = ({ children }) => {
  const navigate = useNavigate();
  const sessionData = getSessionData();
  const { layout } = useDashboardLayout();

  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const toggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  const handleResize = () => {
    const isSmall = window.innerWidth < 768;
    setIsSmallScreen(isSmall);
    setCollapsed(isSmall);
  };

  useEffect(() => {
    if (sessionData) {
      sessionData?.userClassification ===
      SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value
        ? navigate("/admin-dashboard")
        : navigate("/dashboard");
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [sessionData, navigate]);

  return (
    <Layout hasSider data-layout={layout} className={`bl-layout--${layout}`}>
      {/* Sidebar Sider */}
      <Sider
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={270}
        collapsedWidth={0}
        style={{
          overflow: "hidden",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100, // Keep the sidebar always above the content and backdrop
          transition: "left 0.3s ease",
        }}
        breakpoint="md"
        onBreakpoint={(broken) => {
          setCollapsed(broken);
          setIsSmallScreen(broken);
        }}
      >
        <Sidebar collapsed={collapsed} type="portal" />
      </Sider>

      {/* MenuOutlined icon for toggling sidebar on small screens */}
      {collapsed && isSmallScreen && (
        <MenuOutlined
          style={{
            position: "fixed",
            top: 20,
            left: 20,
            zIndex: 120,
            cursor: "pointer",
          }}
          onClick={toggleCollapsed}
        />
      )}

      {/* Backdrop */}
      {!collapsed && isSmallScreen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 90,
          }}
          onClick={toggleCollapsed}
        />
      )}

      {/* Main Layout */}
      <Layout
        style={{
          marginLeft: isSmallScreen ? 0 : 270,
          transition: "margin-left 0.2s ease",
        }}
      >
        {/* Main Content */}
        <Content
          style={{
            backgroundColor: "white",
            overflow: "auto",
            padding: "24px",
          }}
        >
          <div className="min-h-[100vh] h-auto">{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PortalLayout;
